import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-mist mt-24 md:mt-40">
      <div className="container-page py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <Link to="/" className="inline-block text-ink" aria-label="Home">
            <Logo size={14} className="text-left" />
          </Link>
          <p className="mt-6 text-sm leading-relaxed text-smoke max-w-sm">
            An architectural practice based at Bhavnagar, Gujarat — established 1976.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-5">Studio</div>
          <address className="not-italic text-sm leading-relaxed">
            1939/A, Rupani Circle,<br />
            Sardarnagar,<br />
            Bhavnagar — 364001,<br />
            Gujarat, India
          </address>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-5">Contact</div>
          <ul className="text-sm leading-relaxed space-y-1">
            <li>
              <a href="tel:+919426209548" className="hover:opacity-60 transition-opacity">
                +91 94262 09548
              </a>
            </li>
            <li>
              <a href="mailto:contact@rcmnrm.co.in" className="hover:opacity-60 transition-opacity">
                contact@rcmnrm.co.in
              </a>
            </li>
            <li className="pt-3 flex gap-4">
              <a href="https://www.facebook.com/rm.nm.architects" target="_blank" rel="noreferrer" className="text-xs tracking-widest2 uppercase hover:opacity-60 transition-opacity">
                Facebook
              </a>
              <a href="https://www.instagram.com/rm.nm.architects/" target="_blank" rel="noreferrer" className="text-xs tracking-widest2 uppercase hover:opacity-60 transition-opacity">
                Instagram
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="eyebrow mb-5">Menu</div>
          <ul className="text-sm space-y-2">
            <li><Link to="/" className="hover:opacity-60">Home</Link></li>
            <li><Link to="/about" className="hover:opacity-60">About</Link></li>
            <li><Link to="/works" className="hover:opacity-60">Works</Link></li>
            <li><Link to="/publications" className="hover:opacity-60">Publications</Link></li>
            <li><Link to="/contact" className="hover:opacity-60">Contact</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-mist">
        <div className="container-page py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[11px] tracking-widest2 uppercase text-smoke">
          <div>© {year} RM.NM Architects. All rights reserved.</div>
          <div>
            Developed by{" "}
            <a
              href="https://www.shreepatisystems.com/"
              target="_blank"
              rel="noreferrer"
              className="text-ink hover:opacity-60 transition-opacity"
            >
              Shreepati Systems
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
